import { Box, Chip } from "@mui/material";

function NearMissTags({ tags = [] }) {
  // Names (including unnamed-tag fallbacks) and visibility are owned by the API.
  const items = Array.from(
    new Map(tags.map((tag) => [tag.id, tag])).values()
  ).sort((a, b) =>
    a.displayName.localeCompare(b.displayName, "en", { sensitivity: "base" })
  );

  if (items.length === 0) return null;

  return (
    <Box component="section" aria-label="Tags" sx={{ mt: 2 }}>
      <Box
        component="ul"
        role="list"
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          listStyle: "none",
          m: 0,
          p: 0,
        }}
      >
        {items.map((tag) => (
          <Box component="li" key={tag.id} sx={{ maxWidth: "100%" }}>
            <Chip
              label={tag.displayName}
              size="small"
              variant="outlined"
              sx={{
                height: "auto",
                maxWidth: "100%",
                "& .MuiChip-label": {
                  whiteSpace: "normal",
                  overflowWrap: "anywhere",
                  py: 0.5,
                },
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default NearMissTags;
